// extracted by mini-css-extract-plugin
export default {"container":"ProductsPage_container__wKZy-","row":"ProductsPage_row__jmmmR"};